module.exports = __webpack_public_path__ + "static/img/Loktar_h5.4899230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Loktar_h5.png
// module id = FuNJ
// module chunks = 34